import { NoGroupHeaderId } from 'owa-mail-group-headers';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import mailStrings from 'owa-strings/owa-mail-strings';
import generateTimeGroupHeaders from './generateTimeGroupHeaders';
import { now } from 'owa-datetime/lib/displaydate/now';
var timeGroupHeaders = [];
// initialize group header
export function initializeTimeGroupHeaders(now) {
    var weekStartDay = getUserConfiguration().UserOptions.WeekStartDay;
    timeGroupHeaders = generateTimeGroupHeaders(now, weekStartDay);
    return timeGroupHeaders;
}
/**
 * Get group time header for a given time
 * @param timeStamp for which to get time group header
 * @return time group header for a given time
 */
export function getTimeGroupHeader(timeStamp) {
    if (timeGroupHeaders.length == 0) {
        initializeTimeGroupHeaders(now());
    }
    for (var i = 0; i < timeGroupHeaders.length; i++) {
        var timeRange = timeGroupHeaders[i];
        // Check if the time is within range by including lower time boundry but excluding upper boundry
        if (timeStamp >= timeRange.rangeStartTime.getTime() &&
            timeStamp < timeRange.rangeEndTime.getTime()) {
            return timeRange;
        }
    }
    // If an item is not in defined group ranges return none type. It should be very rare but in the
    // past we have seen instances of Tomorrow header e.g. in case timer callback is not triggered.
    return {
        headerText: function () { return mailStrings.noneGroupHeader; },
        headerId: NoGroupHeaderId.None,
        rangeStartTime: null,
        rangeEndTime: null,
    };
}
//# sourceMappingURL=timeGroupHeaderGenerator.js.map